import { BodyRow, HeadingRow, ResponsiveGridWhite } from './styles';

import { Col } from 'react-styled-flexboxgrid';
import ListItem from '@/components/Blog/ListItem';
import LoadingIndicator from '@/components/LoadingIndicator';
import NotFoundPage from '@/components/404';
import PageHeadline from '@/components/ui/elements/PageHeadline';
import Pagination from '@/components/Blog/Pagination';
import PropTypes from 'prop-types';
import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import Section from '@/components/ui/Section';
import { useRouter } from 'next/router';

export const BlogList = ({ posts = [], isTagList = false, blogListCopy, numPages, currentPage }) => {
  const router = useRouter();

  if (router.isFallback) {
    return (
      <Section bgColor="white">
        <LoadingIndicator text="Loading" />
      </Section>
    );
  }

  if (!posts || posts.length === 0) {
    return <NotFoundPage />;
  }

  return (
    <Section bgColor="blue">
      <ResponsiveGrid>
        <HeadingRow>
          <Col xs={12} sm={9} md={8} lg={12}>
            <PageHeadline color="white">{blogListCopy.heading}</PageHeadline>
          </Col>
        </HeadingRow>
        <HeadingRow>
          <Col xs={12} sm={7} md={6} lg={6}>
            <h4>{blogListCopy.subheading}</h4>
          </Col>
        </HeadingRow>
      </ResponsiveGrid>
      <ResponsiveGridWhite>
        <BodyRow center="xs">
          {posts.map((post, index) => (
            <Col key={post._id} xs={12} sm={10} md={8} lg={8}>
              <ListItem {...post} priority={index === 0} />
            </Col>
          ))}
        </BodyRow>
        {numPages > 1 && !isTagList && (
          <BodyRow center="xs">
            <Col xs={12} sm={10} md={8} lg={8}>
              <Pagination numPages={numPages} currentPage={currentPage} />
            </Col>
          </BodyRow>
        )}
      </ResponsiveGridWhite>
    </Section>
  );
};

BlogList.propTypes = {
  posts: PropTypes.array.isRequired,
  blogListCopy: PropTypes.object.isRequired,
};

export default BlogList;
